export default {
  reveseral_amount: 'Monto de reversión',
  account_overview: 'Resumen de la cuenta',
  balance: 'Saldo',
  balance_available: 'Saldo disponible',
  top_up: 'Recargar',
  cash_out: 'Retirar fondos',
  settlement_cycle: 'Ciclo de liquidación',
  settlement_amount: 'Monto de liquidación',
  transactions_number: 'Cantidad de transacciones',
  transaction_status: 'Estado de la transacción',
  transaction_date: 'Fecha de la transacción',
  response_date: 'Fecha de respuesta del callback',
  transaction_type: 'Tipo de transacción',
  update_time: 'Fecha y hora de actualización',
  withdraw_time: 'Fecha y hora del retiro',
  recharge_time: 'Fecha y hora de la recarga',
  details: 'Detalles',
  details_excel_download: 'Descargar detalles en Excel',
  merchant_order_id: 'ID de orden del comercio',
  transaction_id: 'ID de transacción',
  pay_trans_id: 'ID de la transacción de pago',
  po_trans_id: 'ID de la transacción de desembolso',
  create_time: 'Fecha y hora de creación',
  complete_time: 'Fecha y hora de finalización',
  po_fee_plan_id: 'ID de la plantilla de tarifas de desembolso',
  recipient_name: 'Nombre del beneficiario',
  recipient_id_type: 'Tipo de documento del beneficiario',
  recipient_id: 'ID de documento del beneficiario',
  recipient_birth_date: 'Fecha de nacimiento del beneficiario',
  recipient_mobile: 'Teléfono móvil del beneficiario',
  recipient_channel: 'Canal de recepción',
  recipient_account: 'Cuenta del beneficiario',
  account_holder_name: 'Nombre del titular de la cuenta',
  account_no: 'Número de cuenta',
  recipient_card: 'cuanta del beneficiario',
  money_source: 'Origen de los fondos',
  po_fee: 'Tarifa de servicio',
  po_trans_status: 'Estado de la transacción',
  cash_out_date: 'Fecha de retiro',
  amount: 'Monto',
  operator: 'Operador',
  status: 'Estado',
  note: 'Notas',
  balance_record_type: 'Categoría de cambio',
  init_balance: 'Saldo inicial',
  balance_record_id: 'ID de registro de saldo',
  transaction_amount: 'Monto de la transacción',
  balance_record_status: 'Estado del registro de saldo',
  current_balance: 'Saldo actual',
  remitter_information: 'Información del remitente',
  payee_information: 'Información del beneficiario',
  enter_recharge_amount: 'Por favor, ingrese el monto a recargar',
  enter_withdraw_amount: 'Por favor, ingrese el monto a retirar',
  withdrawal_account_information: 'Información de la cuenta de retiro',
  bank: 'Nombre del banco',
  bank_account: 'Número de cuenta bancaria',
  bank_account_name: 'Titular de la cuenta bancaria',
  bank_address: 'Dirección del banco',
  in_transit_settlement_amount: 'Monto de liquidación en tránsito',
  amount_in_transit: 'Monto en tránsito',
  amount_adb: 'Monto ADB',
  branch_no: 'Código de sucursal',
  courier_no: 'Código de repartidor',
  region_no: 'Código de región',
  beneficiary_name: 'Nombre del beneficiario',
  beneficiary_mobile: 'Móvil del beneficiario',
  beneficiary_email: 'Correo electrónico del beneficiario',
  beneficiary_account_type: 'Tipo de cuenta del beneficiario',
  account_type: 'Tipo de cuenta',
  account_type_mobile_number: 'Número de teléfono móvil',
  account_type_ewallet_id: 'Billetera electrónica',
  beneficiary_type: 'Tipo de beneficiario',
  beneficiary_category: 'Categoría del beneficiario',
  beneficiary_category_placeholder: 'Seleccione la categoría del beneficiario',
  beneficiary_category_required: 'La categoría del beneficiario no puede estar vacía',
  beneficiary_category_individual: 'Persona',
  beneficiary_category_organization: 'Empresa',
  short_name: 'Nombre corto',
  receiving_channel: 'Canal de recepción',
  amount_limit: 'Límite disponible / restante',
  beneficiary_account_no: 'Número de cuenta del beneficiario',
  expire_time: 'Fecha de expiración',
  review_comments: 'Comentarios de la revisión',
  available_balance: 'Saldo disponible',
  beneficiary: 'Beneficiario',
  beneficiary_channel: 'Canal del beneficiario',
  beneficiary_account: 'Cuenta del beneficiario',
  beneficiary_id: 'ID del beneficiario',
  add_a_beneficiary: 'Agregar un beneficiario',
  permanent: 'Vigencia permanente',
  account_details: 'Detalles de la cuenta',
  information_details: 'Detalles de la información',
  other: 'Otros',
  attachments: 'Adjuntos adjuntos',
  beneficiary_details: 'Detalles del beneficiario',
  payment_details: 'Detalles del pago',
  beneficiary_account_information: 'Información de la cuenta del beneficiario',
  basic_company_information_of_beneficiary: 'Información corporativa del beneficiario',
  full_legal_entity_name_of_beneficiary: 'Razón social del beneficiario',
  registered_country: 'País/Región de registro',
  registered_address: 'Dirección de registro',
  authorized_representative: 'Representante autorizado',
  signature_of_the_beneficiary: 'Firma del beneficiario',
  full_name: 'Nombre completo',
  position: 'Cargo',
  click_to_sign: 'Haga clic para firmar',
  payment_description: 'Descripción del pago',
  cash_out_threshold: 'Monto mínimo para retiro',
  nsds_bill_summary: 'Resumen de facturación NSDS',
  amount_used: 'Monto utilizado de NSDS pendiente de pago',
  service_fee: 'Comisión por servicio de NSDS pendiente de pago',
  repayment_details: 'Detalles del pago',
  repayment_plan_amount: 'Monto planificado de pago',
  discount: 'Descuentos disponibles',
  total: 'Total',
  go_to_pay: 'Realizar el pago',
  bill_date: 'Fecha de la factura',
  currency: 'Moneda',
  nsds_usage_date: 'Fecha de uso de NSDS',
  nsds_usage_amount: 'Monto utilizado de NSDS',
  nsds_service_fee: 'Tarifa de servicio NSDS',
  billing_type: 'Tipo de facturación',
  bill_total_amount: 'Monto total de la factura',
  paid_amount: 'Pagado',
  pending_amount: 'Pendiente de pago',
  settled: 'Liquidado',
  unsettled: 'No liquidado',
  bill_status: 'Estado de la factura',
  nsds_payment_amount: 'Monto de pago NSDS',
  discount_tip_1: 'Para las tarifas de servicio generadas por el uso de fondos NSDS en el día D, si el capital se reembolsa antes de la hora configurada en el día D+1 (por ejemplo, ',
  discount_tip_2: ') y la factura actual se liquida en su totalidad, podrá disfrutar del beneficio de exención de la tarifa de servicio.',
  settlement_date: 'Fecha de liquidación',
  per_transaction: 'Por transacción',
  per_day: 'Por día',
  payment_remark: 'Comentario de pago',
  cancel_cash_out: 'Cancelar retiro',
  cancel_reason: 'Motivo de cancelación',
  confirm_cash_out: 'Confirmar retiro',
  withdraw_details: 'Detalles del retiro',
  cancel_reason_placeholder: 'Por favor, ingrese el motivo de la cancelación...',
  cancel_reason_required: 'El motivo de la cancelación no puede estar vacío',
  cancel_reason_length: 'La longitud debe tener entre 1 y 200 caracteres'
}
